<ng-container *ngIf="showPaymentActions">
  <div *ngIf="documentPayments?.transactions.size > 0" class="action-wrapper">
    <i2g-router-link
      class="action payment-history-action"
      e2eId="payment-history-action"
      [label]="'ACTION.VIEW_TRANSACTION_HISTORY' | translate"
      [route]="transactionHistoryRoute"
      [trackingObject]="documentTrackingObject"
      [trackingAction]="paymentHistoryButtonTapped"
    >
    </i2g-router-link>
  </div>

  <div
    *ngIf="documentCalculationResult?.outstandingBalance > 0"
    class="action-wrapper"
  >
    <button
      type="button"
      class="action add-payment-action"
      data-e2e-id="add-payment-action"
      [disabled]="!documentAllAccess"
      trackable
      [trackingObject]="documentTrackingObject"
      [trackingAction]="addPaymentButtonTapped"
      (click)="openManualPaymentDialog()"
    >
      {{ 'ACTION.ADD_PAYMENT' | translate }}
    </button>
  </div>

  <app-manual-payment-dialog
    [document]="document"
    [trackingScreenName]="trackingScreenName"
    [currencyCode]="documentSettings?.currencyCode"
    [locale]="documentSettings?.locale"
    [calculationResult]="documentCalculationResult"
    [companySettings]="companySettings"
    [documentBilling]="documentBilling"
    [paymentUrl]="documentPaymentUrl"
    [isKicEnablingPayment]="isKicEnablingPayment$ | async"
    [invalidEmailDialogId]="invalidEmailDialogId"
    (onAddManualPayment)="createManualPayment($event)"
    (onKICPaymentSuccess)="refreshTransactions()"
    (onSendPreviewReceipt)="sendPreviewReceipt($event)"
    (onEnableCardPayments)="onEnableCardPayments()"
  >
  </app-manual-payment-dialog>
</ng-container>

<div
  *ngIf="
    enableDeposits &&
    documentCalculationResult &&
    (depositRequestAllAccess || depositRequestReadAccess || !!deposit)
  "
  class="action-wrapper deposit-request"
>
  <app-add-deposit-request
    class="add-deposit-request"
    [documentCalculationResult]="documentCalculationResult"
    [deposit]="deposit"
    [addDepositForFuture]="addDepositForFuture"
    [documentLocale]="documentLocale"
    [documentType]="documentType"
    [trackingScreenName]="trackingScreenName"
    [documentSettings]="documentSettings"
    [documentTrackingObject]="documentTrackingObject"
    [depositRequestAllAccess]="depositRequestAllAccess"
    [depositRequestReadAccess]="depositRequestReadAccess"
    [document]="document"
    [documentAllAccess]="documentAllAccess"
    [depositRequestFeatureName]="depositRequestFeatureName"
    [documentDueDate]="documentDueDate"
    [featureToggles]="featureToggles"
    [account]="account"
    [paymentsSettings]="paymentsSettings"
    [enablePaidState]="documentType === DocumentTypesEnum.estimate"
    (onSaveDepositRequest)="saveDepositRequest($event)"
    (onRemoveDepositRequest)="removeDepositRequest()"
    (onUpdateDepositToggleSettings)="onUpdateSettingsContent.emit($event)"
    (onDepositDisabledDialogClose)="onDepositDisabledDialogClose($event)"
    (onDepositDialogPreventOpen)="onDepositDialogPreventOpen()"
  >
  </app-add-deposit-request>
</div>

<ng-container *ngIf="showPaymentActions">
  <div
    *ngIf="documentCalculationResult?.payments.isFullyPaid"
    class="action-wrapper"
  >
    <button
      type="button"
      class="action send-receipt-action"
      [disabled]="!documentAllAccess"
      trackable
      [trackingObject]="documentTrackingObject"
      [trackingAction]="sendReceiptButtonTapped"
      (click)="openSendReceiptDialog()"
    >
      {{ 'ACTION.SEND_RECEIPT' | translate }}
    </button>

    <app-icon
      *ngIf="featureHighlightIcon$ | async as featureHighlightIcon"
      class="icon"
      [icon]="featureHighlightIcon"
      (click)="showPaymentRemindersFeatureHighlightDialog()"
    >
    </app-icon>
  </div>

  <app-send-receipt-dialog
    [trackingScreenName]="trackingScreenName"
    (onSendReceipt)="sendReceipt($event)"
    (onPreviewReceipt)="sendPreviewReceipt($event)"
  >
  </app-send-receipt-dialog>

  <app-confirm-dialog
    [dialogId]="invalidEmailDialogId"
    [confirmTitle]="'LABEL.CLIENT_EMAIL_REQUIRED' | translate"
    [confirmPrompt]="'DIALOG.RECEIPTS.INVALID_EMAIL_INFO' | translate"
    [cancelText]="'ACTION.CANCEL' | translate"
    [yesText]="'ACTION.ADD_CLIENT_EMAIL' | translate"
    [isDeleteAction]="true"
    (onClose)="onInvalidClientEmail($event)"
  >
  </app-confirm-dialog>
</ng-container>
